module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © 2017 易路交响 All rights reserved.   ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#6f6e6e",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.frontVersion) + "--" + _vm._s(_vm.adminVersion))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cc577ee","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/foot.vue
// module id = 331
// module chunks = 15